// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"7b7102db011401c4248e","7043":"6af16ef19c4c31f2c37d"}[chunkId] + ".css";
};